import {
  HOME_CARE_ROS_SAFETY_ASSESSMENT,
  HOME_CARE_ROS_SAFETY_QUESTIONS,
} from "@/pages/app/admin/library/templates/home-care-ros/home-care-ros-data";
import {
  parseHomeCareRosAnswers,
  parseHomeCareRosSelection,
} from "@/pages/app/admin/library/templates/home-care-ros/home-care-ros-utils";
import { isHomeCareItem } from "@/pages/app/provider/scheduling/appointment/encounter/default-forms/home-care/home-care-utils";
import { replaceUnderScoreAddSpace } from "@/utils/utils";

const decodeText = (text: string): string => {
  try {
    return decodeURIComponent(text);
  } catch {
    return text;
  }
};

const humanize = (text: string): string =>
  text.split("|").map(replaceUnderScoreAddSpace).join(", ");

const withComment = (label: string, comment?: string): string =>
  comment ? `${label} (${comment})` : label;

const formatSafetyAssessment = (description: string): string => {
  const answers = parseHomeCareRosAnswers(description);
  return HOME_CARE_ROS_SAFETY_QUESTIONS.filter((q) => answers[q.key])
    .map((question) => {
      const details = (question.followUps ?? [])
        .filter((followUp) => answers[followUp.key])
        .map(
          (followUp) =>
            `${replaceUnderScoreAddSpace(followUp.key)}: ${humanize(decodeText(answers[followUp.key]))}`
        )
        .join(", ");
      return withComment(
        `${replaceUnderScoreAddSpace(question.key)}: ${humanize(decodeText(answers[question.key]))}`,
        details
      );
    })
    .join(", ");
};

/** Home Care values ("Allergy:ere") read as "Allergy (ere)"; other values pass through. */
export const formatHomeCareSummary = (
  name?: string,
  description?: string
): string | undefined => {
  if (
    !description ||
    !isHomeCareItem({ templateNameType: name, description, isSelected: true })
  )
    return description;
  if (name === HOME_CARE_ROS_SAFETY_ASSESSMENT)
    return formatSafetyAssessment(description);
  return Object.entries(parseHomeCareRosSelection(description))
    .map(([label, text]) => withComment(replaceUnderScoreAddSpace(label), text))
    .join(", ");
};
